// extracted by mini-css-extract-plugin
module.exports = {"internalLink":"_21eUxeUVCCtfkaJYm2SaxZ","disabled":"_3nEKK1WeXqyxVpO-n-zHH8","primaryAction":"_2VGYxBkCWnqcBQYvnCj_x4"};